import React from "react";
import { CalendarOff } from "lucide-react";

const fmt = (iso) => new Date(iso + "T12:00").toLocaleDateString("fr-FR", { weekday: "short", day: "numeric", month: "short" });

/** Choix Sauter / Reporter (veille ou lendemain ouvré) pour chaque date de contrat tombant un jour férié. */
const HolidayChoices = ({ preview, reports, onChange }) => {
  const rows = (preview?.contracts || []).flatMap((c) => (c.holidays || []).map((h) => ({ ...h, contract_id: c.contract_id, client_nom: c.client_nom })));
  if (!rows.length) return null;
  return (
    <div className="md:col-span-3 border-t border-neutral-100 pt-3" data-testid="holiday-choices">
      <p className="text-sm font-semibold text-amber-700 flex items-center gap-1.5 mb-2"><CalendarOff size={15} /> {rows.length} jour(s) férié(s) sauté(s) automatiquement — choisissez un report si besoin :</p>
      <div className="space-y-1.5">
        {rows.map((h) => {
          const key = `${h.contract_id}|${h.date}`;
          const val = reports[key] || "skip";
          return (
            <div key={key} className="flex flex-wrap items-center gap-2 text-sm" data-testid={`holiday-row-${key}`}>
              <span className="font-medium text-neutral-800 min-w-[140px]">{h.client_nom}</span>
              <span className="text-neutral-600 capitalize">{fmt(h.date)}</span>
              <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-amber-100 text-amber-800">{h.nom}</span>
              <select value={val} onChange={(e) => onChange(key, e.target.value)} data-testid={`holiday-select-${key}`} className="border border-neutral-300 rounded-md px-2 py-1 text-xs bg-white">
                <option value="skip">Sauter (pas d'intervention)</option>
                <option value="veille">Reporter la veille ({fmt(h.veille)})</option>
                <option value="lendemain">Reporter le lendemain ({fmt(h.lendemain)})</option>
              </select>
              {h.already && <span className="text-[11px] text-neutral-400">créneau de report déjà planifié</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HolidayChoices;
